import React, { useEffect, useState } from 'react'
import { GetPaymentProviderTransaction } from '../../api/services/pms'
import { onError } from '../shared/messages'
import CardList from './cardList'
import PropTypes from "prop-types";
import { EntityType } from '../shared/constants';

const AuthorizationsList = ({ reservation, hotelid, newtoken, header, footer, filterUsed, onLoadListFinished, showAllRelatedCards, ...rest }) => {
    const [authorizations, setAuthorizations] = useState([])

    hotelid = reservation ? reservation.HotelId : hotelid
    const reservationId = reservation ? reservation.Id: null
    const reservationEntity = reservation?.entities?.find?.(
      (e) => e.EntityTypeId === EntityType.Reservation
    );

    const derivedEntityId = showAllRelatedCards
      ? reservation.GuestId
      : reservationEntity?.EntityId || reservation.Id || reservation.FolioId;

    const derivedEntityType = showAllRelatedCards
      ? EntityType.Guest
      : reservationEntity?.EntityId || reservation.Id
      ? EntityType.Reservation
      : EntityType.Folio;

    const reload = async () => {
        try {
            const authorizations = await GetPaymentProviderTransaction({
              HotelId: hotelid,
              EntityId: derivedEntityId,
              EntityType: derivedEntityType,
              //Authorizations are first saved on guest and only thereafter added to reservation
              PaymentProviderTransactionTypeId: 2, // AUTHORIZATIONS
            });
            setAuthorizations(filterUsed?authorizations.filter(x=>x.UsedAmount === null):authorizations)
            if(onLoadListFinished){
                const noOfItems = filterUsed ? authorizations.filter(x=>x.UsedAmount === null).length : authorizations.length;
                onLoadListFinished("SavedAuthorizations", noOfItems)
            }

        } catch (error) {
            onError(error)
        }
    }

    useEffect(() => {
        if (reservationId) {
            reload()
        }
    }, [reservationId, showAllRelatedCards])

    useEffect(() => {
        if (newtoken) {
            setAuthorizations([
                ...authorizations,
                newtoken
            ])
        }
    }, [newtoken])

    return authorizations.length?<div>
        {header}
        <CardList items={authorizations} authorization {...rest} />
        {footer}
    </div>:null
}

AuthorizationsList.propTypes = {
    reservation: PropTypes.any,
    hotelid: PropTypes.any,
    header: PropTypes.any,
    footer: PropTypes.any,
    newtoken: PropTypes.any,
    filterUsed: PropTypes.bool,
    onLoadListFinished: PropTypes.func,
    showAllRelatedCards: PropTypes.bool,
}

export default AuthorizationsList